import { IActivityThemeModel } from './ActivityTheme';
import { AxiosPromise } from 'axios';
import { AuthHelper } from 'src/helpers/AuthHelper';
import { WebHelper } from 'src/helpers/WebHelper';
import { PortalDummyAPI } from '../DataDummy/DataApi';
// import { PortalDummyAPI } from '../DataDummy/DataApi';

// service 
export class ActivityThemeService{ // Need to change to User local implementation
    public static getActivityThemes() : AxiosPromise<IActivityThemeModel[]> {
        try{           
                const userToken = AuthHelper.GetUserToken();
                if(userToken === undefined || userToken === ''){
                    throw Error("ActivityThemeService -getActivityThemes-> token not set");
                }
                WebHelper.Instance.headers =
                { 
                    'Authorization': "Bearer " + userToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-Client': 'application',
                    'Pragma': 'no-cache',
                    'Cache-Control': 'no-cache'
                }
                const webInstance = WebHelper.Instance.getAxiosInstance();            
                return webInstance.get('activity/GetPortalData');
            
        } catch(e){
            
            throw e;
        }
    }

    public static GetLocalActivityThemes(): any {
        return  PortalDummyAPI.GetLocalPortalData();
    }

    

}


// WEBPACK FOOTER //
// ./src/Entities/ActivityTheme/ActivityTheme.Service.ts